import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import { ROOT_MODAL_PRESENTATION_PROP } from 'components/Drawers/standardDrawerContract';

import type { SelectLogoDialogProps } from './index';

export const SELECT_LOGO_DIALOG = 'SELECT_LOGO_DIALOG';

const openSelectLogoDialog = (): ((props: SelectLogoDialogProps) => void) => {
  return (props: SelectLogoDialogProps): void => {
    store?.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: SELECT_LOGO_DIALOG,
          type: SELECT_LOGO_DIALOG,
          props: ImmutableMap({
            [ROOT_MODAL_PRESENTATION_PROP]: 'modal',
            ...props,
          }),
        }),
      ),
    );
  };
};

export default openSelectLogoDialog;
